import React, { useCallback, useEffect, useState } from 'react';
import './CountDownClock.scss';
import moment from 'moment';
import useIGTranslation from 'hooks/useIGTranslation';
export interface CountDownClockProps {
  roundStartTime?: number;
  remainingTime?: number;
}

const CountDownClock = ({ roundStartTime }: CountDownClockProps) => {
  const { t } = useIGTranslation();

  const [hours, setHours] = useState<number>(0);
  const [days, setDays] = useState<number>(0);
  const [minutes, setMinutes] = useState<number>(0);
  const [seconds, setSeconds] = useState<number>(0);

  const getRemainingTime = useCallback(() => {
    if (!!roundStartTime) {
      const remainingTime = roundStartTime - new Date().getTime();
      setDays(moment.duration(remainingTime).days());
      setHours(moment.duration(remainingTime).hours());
      setMinutes(moment.duration(remainingTime).minutes());
      setSeconds(moment.duration(remainingTime).seconds());
    }
  }, [roundStartTime]);

  useEffect(() => {
    // Update State every second with new time
    const interval = setInterval(() => {
      getRemainingTime();
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [roundStartTime, getRemainingTime]);

  if (seconds < 0) {
    window.location.reload();
  }

  const formatTimeSegment = (time: number) => {
    return time < 10 ? `0${time}` : time;
  };

  return (
    <div className="count-down-clock" data-testid="count-down-clock">
      <div className="count-down-clock__time-block">
        <div className="count-down-clock__time-block__round-starts-in-text">{t('round-starts-in')}</div>
        <div className="count-down-clock__time-block__days">{formatTimeSegment(days)}</div>
        <div className="count-down-clock__time-block__hours">{formatTimeSegment(hours)}</div>
        <div className="count-down-clock__time-block__minutes">{formatTimeSegment(minutes)}</div>
      </div>
      <div className="count-down-clock__text">{t('days')}</div>
      <div className="count-down-clock__text">{t('hours')}</div>
      <div className="count-down-clock__text">{t('mins')}</div>
    </div>
  );
};

export default CountDownClock;
